export const buildFilterDefaultsSignature = ({ fields, groupedModo } = {}) => {
  const list = Array.isArray(fields) ? fields.map(buildFieldSignature) : []
  return JSON.stringify([groupedModo, list])
}

export const buildFieldSignature = (field) => {
  if (field === null || field === undefined) return null
  if (typeof field !== 'object') return field
  return {
    key: field.key,
    default: field.default,
    items: resolveItemKeys(field.items),
    prepend: resolveItemKeys(field.prepend),
    append: resolveItemKeys(field.append),
  }
}

const resolveItemKeys = (items) =>
  Array.isArray(items) ? items.map(resolveItemKey) : []

const resolveItemKey = (item) => {
  if (item === null || item === undefined) return null
  if (typeof item !== 'object') return item
  return item.value === undefined ? item.id : item.value
}
